import { Link } from "react-router-dom";
import { NAV_LINKS } from "./config";
import { useSectionNav } from "./useSectionNav";
import { Logo } from "./Logo";

const SERVICE_COLUMNS = [
  { to: "/business-in-a-box", label: "Business in a Box" },
  { to: "/website-creation", label: "Website Creation" },
  { to: "/checklist", label: "Launch Checklist" },
];

const LEGAL_COLUMNS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Use" },
];

const linkCls =
  "w-fit rounded-sm text-sm font-bold text-paper/55 transition-colors duration-200 hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac focus-visible:ring-offset-2 focus-visible:ring-offset-ink";
const headingCls = "text-xs font-bold uppercase tracking-[0.18em] text-paper/40";

export const Footer = () => {
  const sectionNav = useSectionNav();
  return (
    <footer data-testid="site-footer" className="border-t border-white/[0.06] py-12">
      <div className="mx-auto grid w-full max-w-shell gap-10 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
        <div>
          <Logo testId="footer-logo" markClassName="h-6 w-6" className="text-paper" />
          <p className="mt-3 max-w-xs text-sm text-paper/50">Your peptide brand starts here.</p>
          <p className="mt-6 text-xs text-paper/35">© 2026 PepMuse</p>
        </div>

        <nav aria-label="Services">
          <p className={headingCls}>Services</p>
          <div className="mt-4 flex flex-col gap-3">
            {SERVICE_COLUMNS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-service-${l.to.slice(1)}`} className={linkCls}>
                {l.label}
              </Link>
            ))}
          </div>
        </nav>

        <nav aria-label="Explore">
          <p className={headingCls}>Explore</p>
          <div className="mt-4 flex flex-col gap-3">
            {NAV_LINKS.map(({ id, label }) => (
              <a
                key={id}
                href={`/#${id}`}
                data-testid={`footer-link-${id}`}
                onClick={sectionNav(id)}
                className={linkCls}
              >
                {label}
              </a>
            ))}
            <Link to="/resources" data-testid="footer-link-resources" className={linkCls}>
              Resources
            </Link>
            <Link to="/account" data-testid="footer-link-account" className={linkCls}>
              Account
            </Link>
            <Link to="/compliance-checker" data-testid="footer-link-compliance-checker" className={linkCls}>
              Compliance Checker
            </Link>
          </div>
        </nav>

        <nav aria-label="Legal">
          <p className={headingCls}>Legal</p>
          <div className="mt-4 flex flex-col gap-3">
            {LEGAL_COLUMNS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-legal-${l.to.slice(1)}`} className={linkCls}>
                {l.label}
              </Link>
            ))}
          </div>
        </nav>
      </div>
    </footer>
  );
};
